import { useCallback } from 'react';
import { useFeedQueryContext } from '@core/feed';
import { isFalsy } from '@core/helpers/boolean';
import { isLiveStream } from '@core/livestream/helpers';
import { useLiveStreamActiveUser } from '@core/livestream/hooks/useLiveStreamActiveUser';
import { useEmbedFeedStore } from '@core/widgets/embedFeed/store';
import { useStore } from '@core/widgets/store';
import { videosSelector } from '@core/widgets/store/selectors';
import { useTrackEmbedVideoClick } from '@core/widgets/tracking/useTrackEmbedVideoClick';
import { useFirstPartyLiveStream } from '@embed/hooks/useFirstPartyLiveStream';
import { onNavigateToVideoHelper } from '../VideoPlayer/helpers';
/**
 * Helper hook which provides thumbnail onClick handler.
 */
export const useThumbnailOnClick = ({ appContext, video, params }) => {
    const [{ feed }] = useFeedQueryContext();
    const videos = useStore(videosSelector);
    const { showVideoPlayer } = useEmbedFeedStore((state) => state.actions);
    const trackEmbedVideoClick = useTrackEmbedVideoClick();
    const { isFirstPartyLiveStream, openInFirstParty } = useFirstPartyLiveStream({
        appContext,
        params,
        video,
    });
    const { setActiveWatch } = useLiveStreamActiveUser(video);
    const onThumbnailClick = useCallback((event) => {
        event?.preventDefault();
        // Disable open to full screen if clicking on video with product carousel bottom layout
        if (params.player_deck_layout && !isLiveStream(video)) {
            return;
        }
        trackEmbedVideoClick(video);
        if (!isFirstPartyLiveStream) {
            openInFirstParty();
            return;
        }
        if (onNavigateToVideoHelper({
            params,
            appContext,
            video,
            feed,
            videos,
        })) {
            if (isFalsy(video.has_access_code)) {
                setActiveWatch();
            }
            showVideoPlayer({ video });
        }
    }, [
        appContext,
        feed,
        isFirstPartyLiveStream,
        openInFirstParty,
        params,
        setActiveWatch,
        showVideoPlayer,
        trackEmbedVideoClick,
        video,
        videos,
    ]);
    return { onThumbnailClick };
};
